import { ErrorTextsDisplayed } from '@app/core/models/root-error-page';
import { LoginType } from '@app/shared/utils/enums/login-type.enum';
import { z } from 'zod';
import { DefaultSocials } from './default-socials';

export const ClientFeatureSchema = z.object({
  languagesCombinations: z.string().optional(),
  excludeCookieBanner: z.boolean().optional(),
  excludedFromSocials: z
    .object({
      flag: z.boolean().optional(),
      country: z.string().optional(),
    })
    .optional(),
  loginTypes: z.array(z.nativeEnum(LoginType)).optional(),
  contactSupportUrl: z.string().url().optional(),
  createAccountUrl: z.string().url().optional(),
  handleDisplayedTextInErrorPage: z.custom<ErrorTextsDisplayed>().optional(),
  includedCustomSocials: z.array(z.string()).optional(),
  excludedDefaultSocials: z.array(z.custom<DefaultSocials>()).optional(),
  auth0Id: z.string().optional(),
});

export type ClientFeature = z.infer<typeof ClientFeatureSchema>;
